<template>
    <div>
        <v-container v-if="loadSkeleton">
            <SkeletonLoader tipo="table-heading, card" ruta="aportes" />
        </v-container>
        <v-container v-else class="justify-center align-center custom-content-padding">
            <DialogoRefinanciacionPP v-if="mountDialogo" ref="dialogoRefPP" :key="dialogoKey" />
            <v-card flat>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-card-title class="text-h5 font-weight-bold ">
                            <v-icon class="mr-3" color="primary" size="34">mdi-account-cash-outline</v-icon>
                            Planes de pago
                            <!--  Adhesión a débito automático -->
                        </v-card-title>
                    </v-col>
                </v-row>
            </v-card>
            <DeudaCard v-if="user.tienedeuda === 2" class="pb-2" />
            <div v-else-if="deudaPlanPago.length > 0 && !hayPlanPagoPendiente" class="ma-2">
                <v-card class="rounded-0 ma-2" outlined>
                    <v-card-title>
                        <div class="font-weight-bold primary--text text-h5">
                            Detalle de deuda
                        </div>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <TablaAgrupadaGenerica :items="deudaPlanPago" :headers="headers">
                    </TablaAgrupadaGenerica>
                </v-card>
                <v-card-actions class="pa-0 rounded-0 custom-card-actions-ha" :style="{
                    left: $vuetify.application.left + 'px', height: 'auto'
                }">
                    <v-row class="ma-0 pa-0">
                        <v-col cols="12" md="12" class="d-flex align-end ma-0 py-1"
                            :class="$vuetify.breakpoint.mdAndUp ? 'justify-end' : 'justify-space-between'">
                            <div class="font-weight-bold black--text text-body-1 "
                                :class="$vuetify.breakpoint.mdAndUp ? 'mr-5' : 'mr-2'">
                                Total adeudado:
                            </div>
                            <div class=" font-weight-bold text-h5 primary--text ">
                                {{ formatMoney(deudaPlanPagoTotales.totalPesos) }}
                            </div>
                        </v-col>
                        <v-col cols="12" md="12"
                            :class="$vuetify.breakpoint.mdAndUp ? 'd-flex justify-end pt-0' : 'pt-0'">
                            <v-btn class="pa-5 font-weight-bold text-caption elevation-0" color="primary"
                                :loading="loading" @click="desplegarRefPP" :block="!$vuetify.breakpoint.mdAndUp">
                                <v-icon class="mr-1">mdi-chevron-right</v-icon>
                                FINANCIAR
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </div>

            <div v-else-if="hayPlanPagoPendiente" class="ma-2">
                <v-alert class="rounded-0 font-weight-regular text-body-1" dense outlined color="secondary"
                    icon="mdi-information-outline" elevation="0">
                    Tu solicitud de <span class="font-weight-bold secondary--text">Financiación de Aportes
                        Mensuales</span>
                    ha sido enviada, la misma permanece sujeta a revisión por parte de las áreas correspondientes.
                </v-alert>
            </div>
            <div v-else class="ma-2">
                <!-- Sin v-show: si el mensaje viene vacio igual mostramos un texto
                     de respaldo para que la vista nunca quede en blanco. -->
                <v-alert class="rounded-0 font-weight-regular text-body-1" dense outlined color="secondary"
                    icon="mdi-information-outline" elevation="0">
                    {{ mensajeAMostrar }}
                </v-alert>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FormBoletas from '@/components/forms/FormBoletas.vue';
import DeudaCard from '@/components/cards/DeudaCard.vue';
import FormResumenAportes from '@/components/forms/FormResumenAportes.vue';
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue';
import DialogoRefinanciacionPP from '@/components/dialogos/DialogoRefinanciacionPP.vue';
import TablaAgrupadaGenerica from '@/components/tables/TablaAgrupadaGenerica.vue';

export default {
    name: 'PlanesDePago',
    components: {
        DialogoRefinanciacionPP,
        TablaAgrupadaGenerica,
        FormBoletas,
        DeudaCard,
        FormResumenAportes,
        SkeletonLoader,
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            mountDialogo: false, // Controla la apertura del diálogo de refinanciación
            dialogoKey: 0, // Fuerza recreación del diálogo en cada apertura
            tabs: null,
            selectedBancoId: '',
            loading: false,
            tipoCuenta: '',

            itemsTipoPago: [
                { id: 1, tipPago: 'PAGO DIRECTO CON CBU' },
                { id: 2, tipPago: 'DÉBITO CON TARJETA DE CRÉDITO VISA' }
            ],
            items: ['Débito', 'Crédito'],
            vencimiento: '',
            nrotarjeta: '',
            nombreTarjeta: '',
            tipoPP: '',
            headers: [
                { text: 'TIPO DE APORTE', value: 'tap_desapo', align: 'center', class: 'primary--text text--darken-1', sortable: false },
                { text: 'MES/CUOTA', value: 'mes_cuota', align: 'center', class: 'primary--text text--darken-1', sortable: false },
                /* { text: 'AÑO/CONVENIO', value: 'anio_convenio', align: 'center', class: 'primary--text text--darken-1', sortable: false }, */
                /*     { text: 'DETALLE', value: 'detalle', align: 'center', class: 'primary--text text--darken-1' }, */
                /*    { text: 'CUOTA', value: 'cuota_pura', align: 'center' },
                   { text: 'INTERES', value: 'interes_cuota', align: 'center' },
                   { text: 'SF', value: 'seg_fallec', align: 'center' },
                   { text: 'FF', value: 'ff', align: 'center' }, */
                { text: 'TOTAL', value: 'total', align: 'center', class: 'primary--text text--darken-1', sortable: false },
            ],
            tab: ''
        }
    },
    created() {
        // El reset del modulo mediosDePago se hace en el beforeEnter de la ruta,
        // antes del pedido de deuda. No reponerlo aca: pisaria la respuesta.
    },
    mounted() {

    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'loadSkeleton', 'user']),
        ...mapGetters('mediosDePago', ['deudaPlanPago', 'parametrosPlanPago', 'deudaPlanPagoTotales', 'mensaje']),
        ...mapGetters('tramites', ['hayPlanPagoPendiente']),

        // Texto de respaldo para que la vista nunca quede sin contenido cuando
        // la API no devuelve mensaje.
        mensajeAMostrar() {
            return this.mensaje || 'En este momento no hay información disponible sobre tus planes de pago. Volvé a intentarlo más tarde o comunicate con la Caja.'
        },
    },
    methods: {
        ...mapActions('boletas', ['getBoletasDisponibles', 'getResumenAportes']),
        ...mapActions('mediosDePago', ['getBancos']),

        formatMoney(value) {
            return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
        },

        handleCloseDialogo() {
            this.loading = false;
            //location.reload();
        },

        desplegarRefPP() {
            this.dialogoKey++
            this.mountDialogo = true
            this.loading = true;
            this.$nextTick(() => {
                this.$refs.dialogoRefPP.abrirDialogo().finally(() => {
                    this.loading = false;
                    this.mountDialogo = false;
                });
            });
        },
    }
};
</script>

<style>
.custom-card-actions-ha {
    position: fixed;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    left: 0;
}

.custom-content-padding {
    padding-bottom: 80px;
    /* igual o mayor a la altura del card fijo */
}
</style>